import { BulkUploadStatus, BulkUploadType, UploadTypeMapping } from 'api/Responses/BulkUploadResponses';

export type UpdatedFileType = {
  dataUploadFileType: UploadTypeMapping;
  gsLocation: string;
  file: File;
};
export enum DataUploadFileType {
  DEVICE_DATA = 'Device Upload',
  BOM_DATA = 'BOM Upload',
  DEVICE_ATTACHMENT = 'Device Attachments',
  BOM_ATTACHMENT = 'Set Attachments',
  USS_DATA = 'Set Serial Numbers',
}

export enum UploadedFileStatusType {
  ACTION_REQUIRED = 'Action Required',
  PENDING = 'Pending',
  MERGED = 'Merged',
  FAILED = 'Failed',
}

export enum DataUploadCheckStatus {
  UNIQUE = 'Unique',
  UPDATE = 'Update',
  IGNORE = 'Ignore',
  DEFAULT = 'Default',
}

export type DataUploadFilesType = Record<string, UpdatedFileType>;

export const getFileUploadInfo = (file: File): string => {
  return `${file.name} (${convertBytesToMBString(file.size)})`;
};

export const convertBytesToMBString = (bytes: number): string => {
  return `${(bytes / 1024 ** 2).toFixed(2)}MB`;
};

export const acceptedFileTypeCSV = [
  '.csv',
  'text/csv',
  'application/vnd.ms-excel',
  'application/csv',
  'text/x-csv',
  'application/x-csv',
  'text/comma-separated-values',
  'text/x-comma-separated-values',
];

export const acceptedFileTypeZIP = ['.zip', 'application/zip', 'application/x-zip-compressed', 'multipart/x-zip'];

export const acceptedFileType = [...acceptedFileTypeCSV, ...acceptedFileTypeZIP];

export const isFileContentTypeCSV = (file: File): boolean => {
  return file.type === 'csv';
};

export const isFileContentTypeZIP = (file: File): boolean => {
  return file.type === 'zip';
};

export const isActionRequired = (file: BulkUploadType): boolean => {
  return file.status === BulkUploadStatus.UPLOAD_CHECK_COMPLETE;
};

export const getDataUploadSaveFilePath = (uuid: string, fileName: string): string => {
  return `bulk_uploads/files/${uuid}/${fileName}`;
};
